import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
const Close = ({ className }) => {
    return (_jsx("svg", { className: cn(className), xmlns: "http://www.w3.org/2000/svg", height: "14", width: "14", viewBox: "0 96 960 960", children: _jsx("path", { fill: "#0062B8", d: "m249 849-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z" }) }));
};
export default Close;
